exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".solutn-slider-box a:hover {\n    text-decoration: none;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/online-mcq/overallreport/overallreport.component.css
// module id = ../../../../../src/app/online-mcq/overallreport/overallreport.component.css
// module chunks = common